import { QqMessageProcessorBase } from "./qq-message-processor.base";
import { QqActionType } from "../qq-action.type";
import { QqStateType } from "../qq-state.type";
import { OptionProcessorService } from "../../services/option-processor.service";

export class DropdownProcessor extends QqMessageProcessorBase {
  process(action: QqActionType, state: QqStateType): QqStateType {
    if (!action.data.qq.optionsValue) return state;

    state.ctrlPos[action.data.qq.key] = action.data.selection;

    const selectedOption = action.data.selection ?? "";
    state.currentOptions[action.data.qq.key] = selectedOption;
    if (state.currentValues[action.data.qq.key])
      delete state.currentValues[action.data.qq.key];

    const optionsProcessor = new OptionProcessorService(
      state.qqBundle,
      state.ctrlBundle,
      state.currentOptions,
      state.currentValues,
      state.ctrlPos
    );

    const optionRes = action.data.qq.optionsValue[selectedOption];
    optionsProcessor.processOption(action.data.qq, optionRes);
    optionsProcessor.ensureBundledCtrlsVisibility(
      action.data.qq.key,
      selectedOption,
      state.ctrlBundle
    );

    return { ...state };
  }
}
